<template>
    <section>
        <PageTitle title="Invoice" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/billings_and_subscriptions',title:'Billings And Subscriptions'},{href:'/view_invoice',title:'View Invoice'}]" />
        <div class="row">
            <div class="col-lg-12">
                <div class="wrapper wrapper-content animated fadeInRight">
                    <div class="ibox-content p-xl">
                        <div  id="print-div">
                            <div class="row text-center">
                                <h1><b>Bebambi</b></h1>
                            </div>
                            <div class="row">
                                <div class="col-sm-8">
                                    <address>
                                        <strong>{{selectedRestaurant.name}}</strong><br>
                                        Name: {{selectedRestaurant.billingName}}<br>
                                        Address: {{selectedRestaurant.billingAddress}}<br>
                                        <abbr title="Phone">Phone No:</abbr> {{selectedRestaurant.billingContactNumber}}
                                    </address>
                                </div>

                                <div class="col-sm-4 text-right">
                                    <h4>Invoice No.</h4>
                                    <h4 class="text-navy">{{selectedBilling.invoiceNumber}}</h4>
                                    <p>
                                        <span><strong>Billing Start Date:</strong> {{$moment.parseZone(String(selectedBilling.billingStarted)).local().format('DD/MM/YYYY hh:mm:ss A')}}</span><br/>
                                        <span><strong>Billing End Date:</strong> {{$moment.parseZone(String(selectedBilling.billingEnded)).local().format('DD/MM/YYYY hh:mm:ss A')}}</span>
                                    </p>
                                </div>
                            </div>

                            <div class="table-responsive m-t">
                                <table class="table invoice-table">
                                    <thead>
                                    <tr>
                                        <th>Subscription Name</th>
                                        <th>Billing Start</th>
                                        <th>Billing End</th>
                                        <th>Billed Amount</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><div><strong>Bebambi Standard Subscription</strong></div>
                                                </td>
                                            <td>{{$moment.parseZone(String(selectedBilling.billingStarted)).local().format('DD/MM/YYYY hh:mm:ss A')}}</td>
                                            <td>{{$moment.parseZone(String(selectedBilling.billingEnded)).local().format('DD/MM/YYYY hh:mm:ss A')}}</td>
                                            <td>{{selectedBilling.billedAmount}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <table class="table invoice-total">
                                <tbody>
                                <tr>
                                    <td><strong>Sub Total :</strong></td>
                                    <td>{{selectedBilling.billedAmount}}</td>
                                </tr>
                                <tr>
                                    <td><strong>TAX :</strong></td>
                                    <td>0</td>
                                </tr>
                                <tr>
                                    <td><strong>TOTAL :</strong></td>
                                    <td>{{selectedBilling.billedAmount}}</td>
                                </tr>
                                </tbody>
                            </table>                               
                        </div>
                        <div class="text-right">
                            <button class="btn btn-primary" @click="showRestaurantOrders()"><i class="fa fa-eye"></i> View Orders</button>
                            <button class="btn btn-primary margin" @click="printReceipt()"><i class="fa fa-print"></i> Print</button>
                        </div>                                         
                    </div>
                </div>
            </div>
        </div>
        <RestaurantOrderDetails ref="RestaurantOrderDetails"/>
    </section>
</template>

<script>
    import PageTitle from '@/components/layout_components/PageTitle'
    import RestaurantOrderDetails from '@/components/billings/RestaurantOrdersDetail'
    export default {
        name: "ViewInvoice",
        data () {
            return {
                selectedRestaurant:'',
                selectedBilling:''            
            }
        },
        components: {
            PageTitle,
            RestaurantOrderDetails,
        },         
        mounted: async function(){
            if(this.$route.query.billingId !== undefined && this.$route.query.restaurantId!==undefined){
                console.log(this.$route.query.billingId)
                
                let params= new URLSearchParams();
                params.append("restaurant_id", this.$route.query.restaurantId)
                let restaurantResp =await this.$http.post(this.$store.state.mainAppURL + "restaurants/get_restaurant_by_id", params);
                this.selectedRestaurant = restaurantResp.data;

                let bilingResp= await this.$http.get(this.$store.state.mainAppURL + "billings/get_billing_detail_by_id/" + this.$route.query.billingId);
                this.selectedBilling= bilingResp.data;
            }
        },          
        methods:{
            showRestaurantOrders: async function(){
                console.log(this.selectedBilling.id)
                await this.$refs.RestaurantOrderDetails.load(this.selectedBilling.id);
            },
            printReceipt: function(){

                const prtHtml = document.getElementById('print-div').innerHTML;
                // Get all stylesheets HTML
                let stylesHtml = '';
                for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML;
                }
                // Open the print window
                const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

                WinPrint.document.write(`<!DOCTYPE html>
                <html>
                <head>
                    ${stylesHtml}
                </head>
                <body>
                    ${prtHtml}
                </body>
                </html>`);

                WinPrint.document.close();
                setTimeout(()=>{
                    WinPrint.focus();
                    WinPrint.print();
                    WinPrint.close();                
                }, 500)
            }
        }
    }
</script>
<style scoped>
.margin {
    margin-left: 5px;
}
</style>